import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DirectSubnavComponent } from './direct-subnav.component';
import { SharedModule } from '@app/shared/shared.module';

@NgModule({
  declarations: [DirectSubnavComponent],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule
  ],
  exports: [DirectSubnavComponent]
})
export class DirectSubnavModule { }
